import StoryblokClient, { Richtext } from 'storyblok-js-client';
import { ref } from '@vue/composition-api';

const Storyblok = new StoryblokClient({ accessToken: process.env.NUXT_ENV_STORYBLOK });

// Monkey patch the richTextResolver's textStyle mark
Storyblok.richTextResolver.marks.textStyle = (mark) => {
  if (mark.attrs && mark.attrs.color) {
    return {
      tag: [
        {
          tag: 'span',
          attrs: {
            style: `color: ${mark.attrs.color}`,
          },
        },
      ],
    };
  }
  return {
    tag: ['span'], // fallback to plain span if no color
  };
};

export function useStoryblok() {
  function renderRichText(text: Richtext) {
    return ref(Storyblok.richTextResolver.render(text));
  }

  return {
    renderRichText,
  };
}
